/* constants here should likely be migrated into serverless config call but are here until such changes are made */

export const cartMax = 5;
